import { Folder } from 'src/models/folder';
import { ListItem } from 'src/models/list';

export const adaptFoldersToListItem = (folder: Folder): ListItem => ({
  ...folder,
  parentId: folder.parent_id,
  id: folder.folder_id,
  isLoaded: true,
});
